import { useState, useEffect } from 'react';

export type Theme = 'light' | 'dark' | 'gold' | 'royal' | 'nardo';

const THEME_CLASSES: Theme[] = ['light', 'dark', 'gold', 'royal', 'nardo'];
const THEME_CYCLE: Record<Theme, Theme> = {
  light: 'dark',
  dark: 'gold',
  gold: 'royal',
  royal: 'nardo',
  nardo: 'light',
};
const THEME_LABELS: Record<Theme, string> = {
  light: 'Mode clair',
  dark: 'Mode sombre',
  gold: 'Mode doré',
  royal: 'Mode royal',
  nardo: 'Mode Nardo',
};

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('posvision_theme') as Theme | null;
      if (stored && THEME_CLASSES.includes(stored)) return stored;
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    // Remove all theme classes first
    root.classList.remove('dark', 'gold', 'royal', 'nardo');
    // Apply the active theme class (light = no class)
    if (theme === 'dark') root.classList.add('dark');
    if (theme === 'gold') root.classList.add('gold');
    if (theme === 'royal') root.classList.add('royal');
    if (theme === 'nardo') root.classList.add('nardo');
    localStorage.setItem('posvision_theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => THEME_CYCLE[prev]);
  const setSpecificTheme = (t: Theme) => setTheme(t);

  return {
    theme,
    toggleTheme,
    setSpecificTheme,
    themeLabel: THEME_LABELS[theme],
    nextThemeLabel: THEME_LABELS[THEME_CYCLE[theme]],
  };
}
